import React from 'react';

import cn from 'classnames';

import cls from './Flex.module.css';
import { FlexDirection, FlexJustify, FlexWrap, FlexAlign } from './types';

interface FlexProps extends React.HTMLAttributes<HTMLElement> {
    children: React.ReactNode;

    direction?: FlexDirection;
    justify?: FlexJustify;
    align?: FlexAlign;
    gap?: number | string;
    wrap?: FlexWrap;
    inline?: boolean;
    fullWidth?: boolean;

    style?: React.CSSProperties;
    as?: React.ElementType;
}

export const Flex = React.forwardRef<HTMLElement, FlexProps>(
    (
        {
            children,
            onClick,
            className,
            direction = 'row',
            justify = 'start',
            align = 'center',
            gap,
            wrap = 'nowrap',
            inline = false,
            fullWidth = false,
            style,
            as = 'div',
            ...rest
        },
        ref
    ) => {
        const Tag = as;

        const styles: React.CSSProperties = {
            ...style,
        };

        if (gap !== undefined) {
            styles.gap = typeof gap === 'number' ? `${gap}px` : gap;
        }

        return (
            <Tag
                ref={ref as any}
                className={cn(
                    cls.flex,
                    inline && cls.inline,
                    cls[`direction_${direction}`],
                    cls[`justify_${justify}`],
                    cls[`align_${align}`],
                    cls[`wrap_${wrap}`],
                    fullWidth && cls.fullWidth,
                    className
                )}
                style={styles}
                onClick={onClick}
                {...rest}
            >
                {children}
            </Tag>
        );
    }
);

Flex.displayName = 'Flex';

// import React from 'react';
//
// import cn from 'classnames';
//
// import cls from './Flex.module.css';
// import { FlexDirection, FlexJustify, FlexWrap, FlexAlign } from './types';
//
// interface FlexProps {
//     children: React.ReactNode;
//     onClick?: () => void;
//     className?: string;
//
//     direction?: FlexDirection;
//     justify?: FlexJustify;
//     align?: FlexAlign;
//     gap?: number | string;
//     wrap?: FlexWrap;
//     inline?: boolean;
//     fullWidth?: boolean;
//     as?: keyof JSX.IntrinsicElements;
// }
//
// export const Flex = ({
//     children,
//     onClick,
//     className,
//     direction = 'row',
//     justify = 'start',
//     align = 'center',
//     gap,
//     wrap = 'nowrap',
//     inline = false,
//     fullWidth = false,
//     as: Tag = 'div',
// }: FlexProps) => {
//     const styles: React.CSSProperties = {};
//
//     if (gap !== undefined) {
//         styles.gap = typeof gap === 'number' ? `${gap}px` : gap;
//     }
//
//     return (
//         <Tag
//             className={cn(
//                 cls.flex,
//                 inline && cls.inline,
//                 cls[`direction_${direction}`],
//                 cls[`justify_${justify}`],
//                 cls[`align_${align}`],
//                 cls[`wrap_${wrap}`],
//                 fullWidth && cls.fullWidth,
//                 className
//             )}
//             style={styles}
//             onClick={onClick}
//         >
//             {children}
//         </Tag>
//     );
// };
